import styled from "styled-components";
import RowOption from '../rowOption.jsx';
import PreviewVideo from "./previewVideo.jsx"

const Container=styled.div`
	width:100%;
	display:flex;
	align-items:center
`
const Info=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	align-items:center;
	margin-bottom:15px;
	padding:15px
`

  const ContainerVideoYoutube=styled.div`
 	height:310px;
 	width:500px;
 `;


export default function VideoDetailGame(props){
	
	let{ value,action,estado}=props;

	


	return(
		<Container>			
      		<h1>Video</h1>
 			<Info>
 				<RowOption label="videopresentacion" value={value.videopresentacion} action={action} estado={estado}/>
 			</Info>
 			<ContainerVideoYoutube>
 				<PreviewVideo url={value.videopresentacion}/> 
 			</ContainerVideoYoutube>
 		</Container>

		)
}